import React from "react";
import style from "./card.module.css";
import "swiper/swiper-bundle.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/parallax";

import RoomOutlinedIcon from "@mui/icons-material/RoomOutlined";
import CropOutlinedIcon from "@mui/icons-material/CropOutlined";
import logger from "../../../../utils/logger";

import { Flat } from "@alptugidin/react-circular-progress-bar";
import 'react-circular-progressbar/dist/styles.css';

import caterpillar from "../../../../images/caterpillar.png";
import moth from "../../../../images/moth.png";
import psilide from "../../../../images/psilide.png";
import beetle from "../../../../images/beetle.png";
import leaf from "../../../../images/leaf.png";

function Card({ plot }) {
  const alternator = (value) => {
    // Validar se value existe e é uma string
    if (!value || typeof value !== "string") {
      logger.warn("Valor de period inválido:", value, "plot:", plot);
      return value || "N/A";
    }

    const parts = value.split(" ");
    
    // Validar se tem partes suficientes
    if (parts.length < 4) {
      logger.warn("Formato de period inválido:", value);
      return value;
    }

    let sem = parts[0];
    let numberSem = parts[1];
    let year = parts[3];
    let month = parts[2];

    if (month === "January.") {
      month = "Jan.";
    } else if (month === "February.") {
      month = "Fev.";
    } else if (month === "March.") {
      month = "Mar.";
    } else if (month === "April.") {
      month = "Abr.";
    } else if (month === "May.") {
      month = "Mai.";
    } else if (month === "June.") {
      month = "Jun.";
    } else if (month === "July.") {
      month = "Jul.";
    } else if (month === "August.") {
      month = "Ago.";
    } else if (month === "September.") {
      month = "Set.";
    } else if (month === "October.") {
      month = "Out.";
    } else if (month === "November.") {
      month = "Nov.";
    } else if (month === "December.") {
      month = "Dez.";
    }

    return `${sem} ${numberSem} ${month} ${year}`;
  };

  const registerColor = (prob) => {
    return prob >= 15 && prob <= 30
      ? "green"
      : prob >= 30.1 && prob <= 50
      ? "#FEC601"
      : "red";
  };

  const registerStatus = (prob) => {
    return prob >= 15 && prob <= 30
      ? "Baixo"
      : prob >= 30.1 && prob <= 50
      ? "Médio"
      : "Alto";
  };

  const verifyPlague = (plague) => {
    return plot.plague ===
      ("Lagarta Parda" ||
        "Lagarta Verde" ||
        "Lagarta Cachorrinho" ||
        "Lagarta Marrom")
      ? caterpillar
      : plot.plague ===
        ("Glena" ||
          "Sarsina" ||
          "Dyrphia" ||
          "Nistalea" ||
          "Hylesia" ||
          "Sabulodes")
      ? moth
      : plot.plague ===
        ("Percevejo Bronzeado" || "Besouro Amarelo" || "Besouro Azul")
      ? beetle
      : psilide;
  };

  // Validar se plot existe e tem propriedades necessárias
  if (!plot) {
    logger.error("Plot não fornecido");
    return <div>Erro: Dados do plot não disponíveis</div>;
  }

  return (
    <div className={style["cards"]}>
      <div className={style["titleCard"]}>
        <RoomOutlinedIcon /> {plot.municipality || "N/A"} - Talhão {plot.plot || "N/A"}
      </div>
      <div className={style["flat"]}>
        <Flat
          showMiniCircle={false}
          progress={plot.prob || 0}
          text={registerStatus(plot.prob || 0)}
          sx={{
            strokeLinecap: "round",
            indicatorCap: "round",
            bgStrokeColor: "#fff",
            strokeColor: registerColor(plot.prob || 0),
            barWidth: 5,
            shape: "threequarters",
            valueSize: 20,
            textSize: 12,
            valueWeight: 500,
            textWeight: 400,
            valueColor: registerColor(plot.prob || 0),
            textColor: registerColor(plot.prob || 0),
          }}
        />
      </div>

      <div className={style["informations-card"]}>
        <div className={style["plague-card"]}>
          <div className={style["plague-card-image"]}>
            <img
              className={style["Images-plagues"]}
              src={verifyPlague(plot.plague)}
              alt={plot.plague || "Praga"}
            />
          </div>
          <div className={style["plague-card-legend"]}>{plot.plague || "N/A"}</div>
        </div>
        <div>
          <div className={style["chance-infestation"]}>
            <div className={style["plague-card-image"]}>
              <CropOutlinedIcon />
            </div>

            <div className={style["chance-infestation-legend"]}>
              {plot.area ? parseFloat(plot.area).toFixed(2) : "0.00"}Ha
            </div>
          </div>
        </div>
        <div>
          <div className={style["plant-card"]}>
            <div className={style["plant-card-image"]}>
              <img src={leaf} alt="Folha" />
            </div>

            <div className={style["plant-legend"]}>{plot.plant || "N/A"}</div>
          </div>
        </div>
      </div>
      <div className={style["forcast-period"]}>Infestação prevista para</div>
      <div className={style["forcast-period"]}>
        <strong>{plot.period ? alternator(plot.period) : "N/A"}</strong>
      </div>
    </div>
  );
}

export default Card;

